import services from './../../services/service'; // Service Class
import HomeLanding from './../Home/index.vue'; // Main Footer
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue'; 

let service = new services();
export default {
    name: 'Home',
    data () {
        return {
            user:{},
            market:{},
            market_groups:{},
            market_trending:{},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            menu_view:{},
            show_login:false,
        }
    },
  
    components: {
        'component-landing': HomeLanding,
        'component-header': MainHeader,
        'component-sticky-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },
    methods: {
        preset_xtra() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                           this.user.user_id = element.user_id;
                           this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, this);
                    }else {
                       //this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                    }
                })
            }else {
               //this.$router.push('login');
            }
        },

        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.loading = false;
                }else {
                    self.show_login=true;
                    // self.$router.push('login');
                    // console.log(err)
                }
            });
        },

        setMarketRemote(){
            service.getBusinessByUserName(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data; 
                    this.loading = false;
                //    this.getProducts();
                }
            }).catch((err) => {
                //maybe no connection ..load from local
               // this.setSellpointLocal(); //removed...caused slower loading
            })
            
        },

        setMarketActivities(){
            service.getMarketActivityProducts(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market_trending = response.body.data; 
                }
            }).catch((err) => {})
        },

        setMarketGroups(){
            service.getMarketGroupsProducts(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market_groups = response.body.data; 
                }
            }).catch((err) => {})
        },

        setMenuComponent(view,view_type,attr1,attr2){  
            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top); 

            this.menu_view = {};
            this.menu_view[view] = true;
            
        },
    
        
    },
    created: function(){
        this.menu_view["timeline"] = true;
        this.preset();
        this.setMarketRemote();
        this.setMarketGroups();
        this.setMarketActivities();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Timeline/script.js